import { Component, OnInit } from '@angular/core';
import { Responsible } from '../../../models/responsible';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { PNotifyService } from './../../../services/pnotify.service';
import { Select2OptionData } from 'ng2-select2';
import * as moment from 'moment';

@Component({
  selector: 'app-responsible-add',
  templateUrl: './responsible-add.component.html',
  styleUrls: ['./responsible-add.component.css']
})
export class ResponsibleAddComponent implements OnInit {

  responsible: Responsible;
  passwordConfirm_ = '';
  pack: Array<Select2OptionData>;
  reservedUsernames: string[];
  clients: any[];
  schools: any[];
  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;
  pnotify = undefined;
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }

  constructor(
    private http: HttpClient,
    private router: Router,
    pnotifyService: PNotifyService
  ) {
    this.responsible = new Responsible();
    this.reservedUsernames = [];
    this.pack = [
      { id: '', text: 'Choisir un type' },
      { id : '1', text: 'Start' },
      { id : '2', text: 'Essentiel' },
      { id : '3', text: 'Pro' },
    ];
    this.http.get(
      '/api/responsible/reservedUsernames/0'
    ).subscribe((usernames: any[]) => {
      for (let i = 0; i < usernames.length; i++) {
        this.reservedUsernames.push(usernames[i].username);
      }
    });
    this.http.get(
      '/api/client/lookup'
    ).subscribe((clients: any[]) => {
      this.clients = clients;
      const array1 = [{ id: '', text: 'Choisir un client' }];
      const array2 = this.clients.map(function (client, index) {
        return { id: client.id, text: client.name };
      });
      this.clientsData = array1.concat(array2);
    });


    this.pnotify = pnotifyService.getPNotify();
  }

  ngOnInit() {
    $('#image-cropper').cropit({
      allowDragNDrop: false,
      smallImage: 'allow',
      imageState: { src: 'assets/images/user.png' }
    });
    $('.select-image-btn').click(function () {
      $('.cropit-image-input').click();
    });
  }

  clientChanged(e: any) {
    const params = new HttpParams({
      fromObject: {
        clientId: e.value + ''
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      const array1 = [{ id: '', text: 'Choisir une école' }];
      const array2 = this.schools.map(function (school, index) {
        return { id: school.id, text: school.name };
      });
      this.schoolsData = array1.concat(array2);
    });
  }

  schoolChanged(e: any) {
    this.responsible.schoolId = e.value;
  }
  onUsernameChange() {
    this.responsible.username = this.responsible.username.replace(/\s/g, '');
  }

  packChanged(e: any) {
    this.responsible.pack = e.value;
  }

  onSubmit(): void {
    this.responsible.expiration = moment(this.responsible.expiration).format('YYYY-MM-DD HH:mm:ss');
    const previewSize = $('#image-cropper').cropit('previewSize');
    const quality = previewSize.width > 100 ? 100 / previewSize.width : 1;
    if ($('#image-cropper').cropit('imageSrc')) {
      this.responsible.image = $('#image-cropper').cropit('export', {
        type: 'image/jpeg',
        quality: quality,
        fillBg: '#fff',
        originalSize: false
      });
    }
    this.http.post(
      '/api/responsible/0',
      { responsible: this.responsible }
    ).subscribe(
      (responsible: Responsible) => {
        this.responsible = responsible;
        this.router.navigate(['/responsible/view', this.responsible.id]);
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/responsible/responsible-add/responsible-add.component.ts